<template>
  <v-app :class="'app ' + (isDarkMode ? 'darkmode' : 'lightmode')">
    <NavBar></NavBar>
    <v-main>
      <div style="max-height: calc(var(--vh, 1vh) * 100 - 60px);" class="h-100 d-flex flex-column overflow-y-auto">
        <router-view />
      </div>
      <PWABanner></PWABanner>
      <HandballNetBanner></HandballNetBanner>
      <CompareButton v-if="this.$store.state.playersToCompare.length > 0"></CompareButton>
    </v-main>
    <!-- Move the HandballNetBanner outside v-main -->
    <v-btn size="small" icon class="consent-button" @click="showBanner">
      <v-icon>mdi-help</v-icon>
    </v-btn>
    <ConsentBanner ref="consentBanner" />
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import PWABanner from '@/components/PWABanner.vue';
import HandballNetBanner from '@/components/HandballNetBanner.vue';
import ConsentBanner from '@/components/ConsentBanner.vue';
import CompareButton from '@/components/CompareButton.vue';

export default {
  name: 'DefaultLayout',
  components: {
    NavBar,
    PWABanner,
    ConsentBanner,
    HandballNetBanner,
    CompareButton
  },
  data: () => ({
    //
  }),
  computed: {
    isDarkMode: {
      get() {
        return this.$store.state.isDarkMode;
      },
      set() {
        this.$store.commit('toggleDarkMode');
      }
    }
  },
  methods: {
    showBanner() {
      this.$refs.consentBanner.show(); // Methode in ConsentBanner, um den Banner anzuzeigen
    }
  },
  mounted() {
    // Diese Funktion setzt die --vh Custom Property auf die aktuelle Viewport-Höhe
    const adjustHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Fügen Sie den Event-Listener hinzu und führen Sie die Funktion sofort aus
    window.addEventListener('resize', adjustHeight);
    adjustHeight(); // Setzen der Variable beim ersten Laden

    // Speichern Sie die Funktion im Instanzbereich, damit sie später entfernt werden kann
    this.adjustHeight = adjustHeight;
  }
}
</script>
<style>
html {
  overflow: hidden !important;
}

.consent-button {
  position: fixed;
  bottom: 13px;
  left: 4px;
  z-index: 10;
  border: 1.5px solid #2a67fc;
}
</style>